  /**
   * Truncates the text to a max length, appending an ellipsis to end of the truncated text.
   * @param {string} text
   * @param {int} maxLength
   * @returns {string}
   */
  export const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      text = text.substring(0, maxLength);
      text = text.substring(0, Math.min(text.length, text.lastIndexOf(' '))) + '...';
    }
    return text;
  };